/* 添加到收藏夹 */

<template>
  <div :class="preflxCls">
    <z-dialog @close="closeDialog">
      <Row type="flex" justify="center">
        <Col :class="preflxCls+'-left'" span="9">
          <div :class="preflxCls+'-left-con'">
            <div class="img-con">
              <img v-if="imgFile" :src="ossUrl + imgFile.key" alt>
              <p class="title">{{txt}}</p>
            </div>
          </div>
        </Col>
        <Col :class="preflxCls+'-right'" span="15">
          <div :class="preflxCls+'-right-main'">
            <p class="title">添加到收藏夹</p>
            <div class="search">
              <Input
                v-model="keyword"
                class="search-input"
                search
                @on-enter="searchAndAdd"
                :maxlength="20"
                placeholder="按Enter去搜索收藏夹"/>
            </div>
            <div class="list-item" v-if="lists && lists.length > 0">
              <Row
                v-for="(item,index) in lists"
                :key="index"
                class="item"
                :class="item.collected ? 'item-active' : ''"
                @click.native="favoritesHandle(item.id,item)"
                type="flex"
                align="middle"
                justify="center"
              >
                <Col class="txt" span="23">{{item.name}}</Col>
                <Col span="1">
                  <i class="iconfont icon-shoucang"></i>
                </Col>
              </Row>
            </div>
            <div v-else style="text-align: center;">
              <z-empty txt="搜索不到收藏夹，快去创建收藏夹吧！"></z-empty>
              <Button @click="createdFav" type="primary">创建收藏夹</Button>
            </div>
          </div>
        </Col>
      </Row>
    </z-dialog>
  </div>
</template>
<script>
const preflxCls = "zAddFavorites";
import { findComponentDownward, randomString } from "../../utils/assist.js";
import ZPanelimg from "../panelimg/panelimg";
import ZDialog from "./dialog";
import dialogs from "../../mixins/dialogs.js";
import Empty from "../empty";
export default {
  name: "ZAddFavorites",
  mixins: [dialogs],
  provide() {
    return {
      app: this
    };
  },
  data() {
    return {
      preflxCls: preflxCls,
      zAddProlog: preflxCls,
      keyword: "",
      collectedList: []
    };
  },
  props: {
    lists: {
      type: Array,
      default: function() {
        return [];
      }
    },
    oldlists: {
      type: Array,
      default: function() {
        return [];
      }
    },
    imgFile: {
      default: ""
    },
    txt: {
      type: String,
      default: ""
    },
    display: {
      type: Boolean,
      default: false
    },

    // oss baseUrl
    ossUrl: {
      type: String,
      default: ""
    }
  },
  components: { ZDialog, ZPanelimg, Empty },

  methods: {
    submit(name) {},

    closeDialog() {
      this.$emit("close");
    },

    /* 创建或者收藏 */
    searchAndAdd() {
      this.onSearch(this.keyword);
    },

    /* 自动匹配搜索 */
    onSearch(keyword) {
      if (!keyword) {
        this.lists = this.oldlists;
      } else {
        this.lists = this.lists.filter(item => {
          if (item.name.indexOf(keyword) > -1) {
            return item;
          }
        });
      }
    },

    /* 创建收藏夹 */
    createdFav() {
      if (!this.keyword) {
        this.$Message.warning("请在搜索框中填写收藏夹名称");
        return false;
      }
      this.$emit("created", this.keyword);
    },

    /* 收藏到收藏夹 */
    favoritesHandle(id, item) {
      if (!id) return false;
      let _index = this.collectedList.indexOf(id);
      if (_index > -1) {
        this.collectedList.splice(_index, 1);
        item.collected = false;
        this.pushLists();
        this.$emit("favoritesAdd", this.collectedList, "cencel");
      } else {
        this.collectedList.push(id);
        item.collected = true;
        this.pushLists();
        this.$emit("favoritesAdd", this.collectedList, "add");
      }
    },

    /* 储存 id */
    pushLists() {
      let ids = [];
      let listsActive = this.lists.filter(item => item.collected) || [];
      listsActive.forEach(element => {
        ids.push(element.id);
      });
      this.collectedList = ids;
    }
  },

  mounted() {
    const Dialog = findComponentDownward(this, "ZDialog");
    if (Dialog) {
      this.diaologDom = Dialog;
    }
  },
  watch: {
    display: function() {
      if (this.display) {
        this.diaologDom.op();
      } else {
        this.diaologDom.close();
      }
    },
    lists: function() {
      this.pushLists();
    }
  }
};
</script>
